/** The decoded value of the named cookie, or undefined when it is absent, empty or not decodable. */
export const readCookie = (name: string): string | undefined => {
  const prefix = `${name}=`
  const value = document.cookie
    .split("; ")
    .find((cookie) => cookie.startsWith(prefix))
    ?.slice(prefix.length)
  if (!value) return undefined
  try {
    return decodeURIComponent(value)
  } catch {
    return undefined
  }
}
